{
	"action": {
		"audit_retention_applied": "Retention applied",
		"authz_denied": "Access refused",
		"group_created": "Group created",
		"group_deleted": "Group deleted",
		"group_member_added": "Person added to a group",
		"group_member_removed": "Person removed from a group",
		"group_updated": "Group changed",
		"link_accessed": "Link opened",
		"link_created": "Link created",
		"link_downloaded": "Downloaded through a link",
		"link_password_locked": "Link locked after wrong passwords",
		"link_previewed": "Previewed through a link",
		"link_revoked": "Link revoked",
		"link_updated": "Link updated",
		"link_upload_limited": "Upload link at its limit",
		"node_purged": "Permanently deleted",
		"node_upload_reconciled": "Upload reconciled",
		"node_version_deleted": "Version deleted",
		"node_versions_expired": "Earlier versions removed",
		"org_link_changed": "Organization access changed",
		"org_link_opened": "Opened through organization access",
		"organization_created": "Organization created",
		"organization_quota_changed": "Organization quota changed",
		"organization_reactivated": "Organization reactivated",
		"organization_storage_destroyed": "Storage destroyed",
		"organization_suspended": "Organization suspended",
		"organization_version_retention_changed": "Version retention changed",
		"policy_changed": "Policy changed",
		"session_force_disconnected": "Signed out by an administrator",
		"session_revoked": "Session ended",
		"share_granted": "Sharing granted",
		"share_revoked": "Sharing revoked",
		"share_role_changed": "Sharing role changed",
		"upload_expired": "Upload expired",
		"user_credentials_changed": "Credentials changed",
		"user_deactivated": "Access withdrawn",
		"user_email_changed": "Email address changed",
		"user_invite_accepted": "Invitation accepted",
		"user_invite_resent": "Invitation resent",
		"user_invited": "Person invited",
		"user_membership_removed": "Removed from the organization",
		"user_owner_granted": "Ownership granted",
		"user_owner_revoked": "Ownership removed",
		"user_quota_changed": "Quota changed",
		"user_reactivated": "Access restored",
		"user_removed": "Person removed",
		"user_role_changed": "Role changed"
	},
	"actor": {
		"device": "Sync device",
		"link_recipient": "Public link visitor",
		"operator": "Platform Operator",
		"system": "System",
		"unknown": "Former member",
		"unknown_hint": "This person is no longer in the organization. The record of what they did stays."
	},
	"batch": {
		"failed_one": "{{count, number}} failed",
		"failed_other": "{{count, number}} failed"
	},
	"batch_kind": {
		"copy_one": "{{count, number}} file copied",
		"copy_other": "{{count, number}} files copied",
		"download_one": "{{count, number}} file downloaded",
		"download_other": "{{count, number}} files downloaded",
		"preview_one": "{{count, number}} file previewed",
		"preview_other": "{{count, number}} files previewed",
		"restore_one": "{{count, number}} item restored from the trash",
		"restore_other": "{{count, number}} items restored from the trash",
		"trash_one": "{{count, number}} item moved to the trash",
		"trash_other": "{{count, number}} items moved to the trash",
		"upload_one": "{{count, number}} file uploaded",
		"upload_other": "{{count, number}} files uploaded",
		"version_restore_one": "Previous version restored on {{count, number}} file",
		"version_restore_other": "Previous version restored on {{count, number}} files"
	},
	"batch_sentence": {
		"copy_one": "Copied {{count, number}} file.",
		"copy_other": "Copied {{count, number}} files.",
		"download_one": "Downloaded {{count, number}} file.",
		"download_other": "Downloaded {{count, number}} files.",
		"preview_one": "Opened the preview of {{count, number}} file.",
		"preview_other": "Opened the preview of {{count, number}} files.",
		"restore_one": "Restored {{count, number}} file or folder from the bin.",
		"restore_other": "Restored {{count, number}} files or folders from the bin.",
		"trash_one": "Moved {{count, number}} file or folder to the bin.",
		"trash_other": "Moved {{count, number}} files or folders to the bin.",
		"upload_one": "Uploaded {{count, number}} file.",
		"upload_other": "Uploaded {{count, number}} files.",
		"version_restore_one": "Restored {{count, number}} file to an earlier version.",
		"version_restore_other": "Restored {{count, number}} files to an earlier version."
	},
	"category": {
		"access": "Access",
		"content": "Content",
		"organization": "Organization",
		"people": "People",
		"sharing": "Sharing"
	},
	"columns": {
		"actor": "Who",
		"timestamp": "When",
		"what": "What"
	},
	"detail": {
		"actor": "Who",
		"bytes": "Data transferred",
		"files_count_one": "{{count, number}} file",
		"files_count_other": "{{count, number}} files",
		"files_failed": "Files failed",
		"files_succeeded": "Files succeeded",
		"metadata": "Details",
		"object_id": "ID",
		"object_type": "Type",
		"origin": "From",
		"outcome": "Outcome",
		"section": {
			"event": "Event",
			"object": "Object",
			"transfer": "Transfer"
		},
		"timestamp": "When",
		"title": "Details",
		"user_agent": "Client",
		"view_person_activity": "All activity for this person"
	},
	"empty": {
		"beyond_retention_description_one": "The period you asked for is entirely older than the {{count}} day this organization keeps. Everything before {{date}} has been removed. This is not a period in which nothing happened.",
		"beyond_retention_description_other": "The period you asked for is entirely older than the {{count}} days this organization keeps. Everything before {{date}} has been removed. This is not a period in which nothing happened.",
		"beyond_retention_title": "These events are no longer kept",
		"description": "As soon as something happens in your organization it appears here, the most recent first.",
		"no_matches_description": "Nothing inside the retention window matches these filters. Try widening the period or removing a filter.",
		"no_matches_title": "No results",
		"title": "Nothing has been recorded yet"
	},
	"filters": {
		"object": "Object",
		"period": "Period",
		"period_default": "Last 30 days",
		"person": "Person",
		"person_placeholder": "Search for a person",
		"type": "Type"
	},
	"object_type": {
		"group": "Group",
		"node": "File or folder",
		"organization": "Organization",
		"policy": "Policy",
		"user": "Person"
	},
	"origin": {
		"api": "API",
		"system": "System",
		"web": "Web"
	},
	"outcome": {
		"failure": "Failed",
		"success": "Done"
	},
	"page_title": "Audit",
	"quota": {
		"no_limit": "no limit"
	},
	"role": {
		"member": "Member",
		"org_admin": "Administrator"
	},
	"sentence": {
		"audit_retention_applied_one": "Applied retention, removing {{count}} event.",
		"audit_retention_applied_other": "Applied retention, removing {{count}} events.",
		"authz_denied": "Attempted an action without the required permission.",
		"group_created": "Created the group <b>{{name}}</b>.",
		"group_deleted": "Deleted the group <b>{{name}}</b>.",
		"group_made_private": "Made the group <b>{{name}}</b> private.",
		"group_made_public": "Made the group <b>{{name}}</b> public.",
		"group_member_added": "Added a person to a group.",
		"group_member_removed": "Removed a person from a group.",
		"group_renamed": "Renamed the group <b>{{previousName}}</b> to <b>{{name}}</b>.",
		"link_accessed": "Opened a public link.",
		"link_created": "Created a public link on a file or folder.",
		"link_created_password_protected": "Created a password-protected public link on a file or folder.",
		"link_downloaded": "Downloaded <b>{{name}}</b> through a public link.",
		"link_password_locked": "A public link stopped accepting passwords after too many wrong ones.",
		"link_previewed": "Opened the preview of <b>{{name}}</b> through a public link.",
		"link_revoked": "Revoked a link.",
		"link_updated": "Changed a link's expiry.",
		"link_upload_limited": "An upload link reached its daily limit and is not taking more files for now.",
		"node_purged": "Permanently deleted an item and all its versions.",
		"node_upload_reconciled": "Reconciled an unconfirmed upload.",
		"node_version_deleted": "Deleted version {{versionNumber}} of a file.",
		"node_versions_expired_one": "Removed {{count}} earlier version that the version retention no longer keeps.",
		"node_versions_expired_other": "Removed {{count}} earlier versions that the version retention no longer keeps.",
		"org_link_closed": "Closed a file or folder to the organization: only the people added keep access.",
		"org_link_opened_to": "Opened a file or folder to everyone in the organization with the link, as {{role}}.",
		"org_link_visited": "Opened a file or folder through its organization access.",
		"organization_created_failure": "Organization provisioning failed.",
		"organization_created_success": "Organization provisioning completed.",
		"organization_quota_changed": "Changed the organization's quota from {{previous}} to {{next}}.",
		"organization_reactivated": "Reactivated the organization.",
		"organization_storage_destroyed_one": "Destroyed the organization's storage ({{count}} item).",
		"organization_storage_destroyed_other": "Destroyed the organization's storage ({{count}} items).",
		"organization_suspended": "Suspended the organization.",
		"organization_suspended_reason": "Suspended the organization: {{reason}}.",
		"organization_version_retention_changed": "Changed how many earlier versions of each file are kept, and for how long.",
		"policy_changed": "Changed the <b>{{key}}</b> policy.",
		"session_force_disconnected": "Disconnected <b>{{name}}</b>.",
		"session_revoked": "Ended a session of <b>{{name}}</b>.",
		"share_granted": "Shared a file or folder with <b>{{subject}}</b> as {{role}}.",
		"share_granted_via_move": "Shared a file or folder with <b>{{subject}}</b> as {{role}}, through a move.",
		"share_revoked": "Revoked <b>{{subject}}</b>'s sharing on a file or folder.",
		"share_revoked_via_move": "Revoked <b>{{subject}}</b>'s sharing on a file or folder, through a move.",
		"share_role_changed": "Changed <b>{{subject}}</b>'s role on a file or folder from {{previousRole}} to {{role}}.",
		"share_role_changed_via_move": "Changed <b>{{subject}}</b>'s role on a file or folder from {{previousRole}} to {{role}}, through a move.",
		"upload_expired_one": "The upload expired after {{count}} minute of inactivity.",
		"upload_expired_other": "The upload expired after {{count}} minutes of inactivity.",
		"user_credentials_changed": {
			"configure_otp": "Added a two-step verification device.",
			"other": "Changed their own sign-in credentials.",
			"regenerate_recovery_codes": "Generated new recovery codes.",
			"remove_otp_device": "Removed a two-step verification device.",
			"update_password": "Changed their own password."
		},
		"user_deactivated": "Suspended <b>{{name}}</b>'s access.",
		"user_deactivated_reason": "Suspended <b>{{name}}</b>'s access: {{reason}}.",
		"user_email_changed": "Corrected <b>{{name}}</b>'s address from {{previousEmail}} to {{newEmail}}.",
		"user_invite_accepted": "Accepted the invitation as {{role}}.",
		"user_invite_resent_one": "Resent the invitation to <b>{{name}}</b> (attempt {{count}}).",
		"user_invite_resent_other": "Resent the invitation to <b>{{name}}</b> (attempt {{count}}).",
		"user_invited": "Invited <b>{{name}}</b> as {{role}}.",
		"user_membership_removed": "Removed <b>{{name}}</b> from the organization.",
		"user_owner_granted": "{{name}} was made an owner of the organization by the platform operator. They were {{previousRole}} before.",
		"user_owner_revoked": "{{name}} is no longer an owner of the organization, by the platform operator. {{remaining}} remain.",
		"user_quota_changed": "Changed <b>{{name}}</b>'s quota from {{previous}} to {{next}}.",
		"user_reactivated": "Restored <b>{{name}}</b>'s access.",
		"user_removed": "Revoked the invitation of <b>{{name}}</b>.",
		"user_role_changed": "Changed <b>{{name}}</b>'s role from {{previousRole}} to {{newRole}}."
	},
	"subject": {
		"group": "a group"
	},
	"total_one": "{{count}} item",
	"total_other": "{{count}} items"
}
